import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

// action types
export const GET_CENTROS_DE_RESPONSABILIDADE = "getCentrosDeResponsabilidade";
export const GET_CENTROS_RESPONSABILIDADE_BOX = "getCentrosResponsabilidadeBox";

// mutation types
export const SET_CENTROS_DE_RESPONSABILIDADE = "setCentrosDeResponsabilidade";

const state = {
  centrosDeResponsabilidade: []
};

const getters = {
  centrosDeResponsabilidade(state) {
    return state.centrosDeResponsabilidade;
  }
};

const actions = {
  [GET_CENTROS_DE_RESPONSABILIDADE](context) {
    return new Promise(resolve => {
      if (JwtService.getToken()) {
        ApiService.setHeader();
        ApiService.get("centrosDeResponsabilidade").then(({ data }) => {
          context.commit(SET_CENTROS_DE_RESPONSABILIDADE, data);
          resolve(data);
        });
      }
    });
  },
  [GET_CENTROS_RESPONSABILIDADE_BOX](context, filtros) {
    return new Promise(resolve => {
      if (JwtService.getToken()) {
        ApiService.setHeader();
        ApiService.post("centrosDeResponsabilidadeBox", filtros).then(
          ({ data }) => {
            resolve(data);
          }
        );
      }
    });
  }
};

const mutations = {
  [SET_CENTROS_DE_RESPONSABILIDADE](state, centrosDeResponsabilidade) {
    state.centrosDeResponsabilidade = centrosDeResponsabilidade;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
